import logo from "../assets/images/Logo-PM.png";
import React, { useState, useEffect, Fragment } from "react";
import "antd/dist/antd.css";
import axios from "axios";
import { setBlueKey } from "../actions/actions";
import Select from "react-select";
import "./Home.css";
import { Radio, Input, Button, notification } from "antd";
import { connect } from "react-redux";
const { Group } = Radio;
const serviceUrl = "https://us-central1-calculadora-pm.cloudfunctions.net/app/";
// const serviceUrl = "/";

const Home = (props) => {
  const [years, setYears] = useState([]);
  const [year, setYear] = useState("");
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState("");
  const [models, setModels] = useState([]);
  const [model, setModel] = useState("");
  const [versions, setVersions] = useState([]);
  const [version, setVersion] = useState("");
  const [blueKey, setBlueKey] = useState("");
  const [km, setKm] = useState("");
  const [creditType, setCreditType] = useState("");
  const [loan, setLoan] = useState(null);

  const usageCtg = [
    { label: "Factura original", value: "facorg" },
    { label: "Refacturado", value: "refc" },
    { label: "Factura aseguradora", value: "facseg" },
    { label: "Plataforma de movilidad (Uber, Didi, Cabify)", value: "pdmov" },
    { label: "Taxi publico", value: "txpu" },
  ];
  const [usage, setUsage] = useState("");

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message,
      duration: 5,
      description,
    });
  };

  const getBlueKey = async () => {
    try {
      const response = await axios({
        url: `${serviceUrl}iniciarSession/`,
        method: "get",
      });
      const key = response.data.IniciarSesionResult;
      await setBlueKey(key);
    } catch (error) {}
  };

  const getLoan = async () => {
    try {
      const response = await axios({
        url: `${serviceUrl}getLoan/${blueKey}/${version.value}/${km}/${creditType}`,
        method: "get",
      });
      setLoan(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getYears = async (Key) => {
    try {
      const response = await axios({
        url: `${serviceUrl}getyears/${Key}`,
        method: "get",
      });
      await setYears(response.data);
    } catch (error) {}
  };

  const getBrands = async (year) => {
    try {
      const response = await axios({
        url: `${serviceUrl}getbrands/${blueKey}/${year}`,
        method: "get",
      });
      setBrands(response.data);
    } catch (error) {}
  };

  const getModel = async (brand) => {
    try {
      const response = await axios({
        url: `${serviceUrl}getmodel/${blueKey}/${year.value}/${brand}`,
        method: "get",
      });
      setModels(response.data);
    } catch (error) {}
  };

  const getVersion = async (model) => {
    try {
      const response = await axios({
        url: `${serviceUrl}getVersion/${blueKey}/${year.value}/${brand.value}/${model}`,
        method: "get",
      });
      setVersions(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    if (blueKey !== "") {
      getYears(blueKey);
    }
  }, [blueKey]);

  useEffect(() => {
    getBlueKey();
  }, []);

  const handleChangeYear = (selectedOption) => {
    setYear(selectedOption);
    getBrands(selectedOption.value);
  };

  const handleChangeBrand = (selectedOption) => {
    setBrand(selectedOption);
    getModel(selectedOption.value);
  };

  const handleChangeModel = (selectedOption) => {
    setModel(selectedOption);
    getVersion(selectedOption.value);
  };

  const handleChangeVersion = (selectedOption) => {
    setVersion(selectedOption);
  };

  const hasErrors = () => {
    let error = false;
    if (usage.value === "txpu" || usage.value === "pdmov") {
      openNotificationWithIcon(
        "error",
        "Alto",
        "Lo sentimos por el tipo de uso que tiene tu carro no podemos seguir con el préstamo."
      );
      error = true;
    } else if (
      km === "" ||
      version.value === "" ||
      creditType === "" ||
      usage.value === ""
    ) {
      openNotificationWithIcon(
        "info",
        "Info",
        "Revisa que hayas llenado todos los campos para poder generar una cotización correcta."
      );
      error = true;
    }

    return error;
  };

  return (
    <div className="container">
      <img className="logo-container" src={logo} alt="" />
      <div className="title">
        <h2>Cotiza el monto de tu préstamo </h2>
      </div>
      <div className="radio-container">
        <Group
          onChange={(e) => {
            setCreditType(e.target.value);
          }}
          value={creditType}
        >
          <Radio value={0.9}>Resguardo</Radio>
          <Radio value={0.8}>GPS</Radio>
        </Group>
      </div>
      <div className="select-container p-top-5">
        <Select
          className="select-item"
          placeholder={"Agrega un Año"}
          value={year}
          onChange={handleChangeYear}
          options={years}
        />
        <Select
          className="select-item m-left-5"
          placeholder={"Agrega una Marca"}
          value={brand}
          onChange={handleChangeBrand}
          options={brands}
        />
      </div>
      <div className="select-container p-top-5">
        <Select
          className="select-item"
          placeholder={"Agrega un Modelo"}
          value={model}
          onChange={handleChangeModel}
          options={models}
        />
        <Select
          className="select-item m-left-5"
          placeholder={"Agrega una Version"}
          value={version}
          onChange={handleChangeVersion}
          options={versions}
        />
      </div>
      <div className="select-container p-top-5">
        <Input
          className="select-item km-input"
          placeholder="Kilómetros"
          value={km}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[0-9]+$/.test(value)) {
              setKm(value);
            }
          }}
        />
        <Select
          className="select-item m-left-5"
          placeholder={"Uso"}
          value={usage}
          onChange={(opt) => {
            setUsage(opt);
          }}
          options={usageCtg}
        />
      </div>
      <Button
        className="button-home m-top-10"
        type="primary"
        onClick={() => {
          if (hasErrors() === false) {
            getLoan();
          }
        }}
      >
        Cotizar
      </Button>
      <div className="verbiage m-top-10">
        {loan !== null ? (
          <Fragment>
            <h2>{`Tu préstamo es de: $ ${new Intl.NumberFormat().format(
              loan.total
            )} ${loan.Moneda}`}</h2>
            <h4>
              Déjanos tus datos y un ejecutivo se comunicara contigo o
              escríbenos a jbastida@prendamovil.com.mx
            </h4>
            <div className="regulation">
              *Los montos son aproximados y de uso informativo, para más detalle
              sobre tu préstamo contáctate con un ejecutivo de Prendamovil
            </div>
          </Fragment>
        ) : (
          <h2>Simula tu préstamo aquí</h2>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => ({
  setBlueKeyAction: (key) => dispatch(setBlueKey(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
